module.exports = __webpack_public_path__ + "static/img/segmentation.e0e59c4.png";


//////////////////
// WEBPACK FOOTER
// ./static/mo/segmentation.png
// module id = H8ER
// module chunks = 0